/**
 * @description 班级环节title组件
 * @author xyguo
 * @date 2020-12-14
 */
import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'dva'
import { modelUtils } from '@/utils'
// import ClassResultPercent  from './classResultPercent'
import { component_tool, framework_tool, utils_tool } from '@/tool'
let {
  WizCard,
  WizBizcharts,
  WizRow,
  WizCol,
  WizTypography
} = component_tool;
let { WizContainer } = framework_tool;
const { Title, Text, Paragraph } = WizTypography

class ClassStudentAideInfo extends WizContainer {

    componentName = 'ClassStudentAideInfo';

    constructor(props){
        super(props);
        this.state={
        }
      }

      /**
     * 头部：名称
     */
    _header = ( title, value) => {
      return (
           <WizRow style={{padding:0,marginLeft:"100px"}}>
            <WizCol span={8}>
              <Text strong >
                  {title[0]}：{value[0]}
             </Text>
            </WizCol>
            <WizCol span={12}>
              <Text strong >
                  {title[1]}：{value[1]}
                </Text>
            </WizCol>
            <WizCol span={4}>
              <Text strong >
                  {title[2]}：{value[2]}
                </Text>
            </WizCol>
          </WizRow>
      )
  };

    _render() {
      const {aideName ,startTime,endTime,stage} = this.props;
      let title = ['环节名称','环节时间','环节阶段'];
      let value = aideName ?[
        aideName,
        startTime+'-'+endTime,
        stage === 0 ? "课前" : stage === 1 ? "课中" : "课后" ]
            :['','',''];
        return [
            <WizCard title={'环节概况'} key={new Date().getTime()} bodyStyle={{paddingLeft:20,paddingBottom:25,paddingTop:25}}>
                {this._header(title,value)}
            </WizCard>
        ]
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
       
    };
};

export default connect(mapStateToProps)(ClassStudentAideInfo);
